<template>
  <div class='hbox'>
    <mu-icon value='remove' @click="reduce"/>
    <input type="number" :value="currentValue" @change="handleChange"  class='myinput' />
    <mu-icon value='add' @click="add"/>
  </div>
</template>
<script>
export default {
    props: {
        max:{
            type:Number,
            default:10000
        },
        min:{
            type:Number,
            default:0
        },
        value:{
            type:Number,
            default:0
        },
        step:{
            type:Number,
            default:1,
        }
    },
    data(){
        return { 
            currentValue:this.value,
        }
    },
    methods:{
        updateValue(val){
          if(val>this.max)val=this.max;
          if(val<this.min)val=this.min;
          if(this.currentValue!=val){
               this.currentValue=val;
              this.$emit('input',this.currentValue)
          }
         

         
        },
        add(){
             this.updateValue(this.currentValue+this.step)
           
           
        },
        reduce(){
            this.updateValue(this.currentValue-this.step)
            
        },
        handleChange(evt){
          let fix;
           if(typeof evt.target.value !=Number){ 
                   fix =Number(evt.target.value.replace(/\D/g, ''))
              }
          else{
                fix = evt.target.value
             }
            this.updateValue(fix);

        },
        
    }
}
</script>
<style scoped>
  .tag{
      font-size: 1rem;
  }
  .myinput {
      width: 100px;
      border:#cccccc 1px solid;
      text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/NumberInput.vue